import ProductComponent from "~/modules/Product";
import type { V2_MetaFunction } from "@remix-run/node";
import type {
  PartnerCountry,
  Product,
  StoreGlobalOffersDetails,
} from "~/common/props/orchestrator";
import { useAppParams } from "@commons-monorepo/index";

import { Outlet, useLoaderData, useOutletContext } from "@remix-run/react";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { getUrlCanonical } from "@commons-monorepo/index";
import EmptyState from "~/components/empty-states/empty-state/empty-state";
import { ReviewComment } from "~/modules/Product/Product.type";

export const productMetaData: V2_MetaFunction = ({ matches }) => {
  const parentsData = matches[0]?.data;
  const product = matches[2]?.data?.data?.product;
  const friendlyUrl = product?.friendlyUrl;
  const pCity = parentsData?.storeMetadata.storeCity;
  const productName = product?.metaTitle || product?.name;
  const description = product?.metaDescription || product?.description;
  const formattedDescription =
    description && description.length > 160
      ? description.slice(0, 160) + "..."
      : description;
  const canonical = getUrlCanonical(parentsData, friendlyUrl);

  return [
    { name: "charset", content: "utf-8" },
    { title: `${productName} ${pCity ? `en ${pCity}` : ``}` },
    { name: "description", content: formattedDescription },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: product?.name },
    { name: "og:image", content: product?.images[0] },
    { name: "og:description", content: description },
    {
      tagName: "link",
      rel: "canonical",
      href: canonical,
    },
  ];
};

export default function Route() {
  const { data, review } = useLoaderData<{
    data: {
      product: Product;
      ownerCountry: PartnerCountry;
      globalOffers: StoreGlobalOffersDetails[];
    };
    review: Array<ReviewComment>;
  }>();
  const { storeMetadata, ...dataContext } = useOutletContext<any>();
  const { offerId } = useAppParams();
  const { cartProducts } = useCart();
  const { product } = data;

  return (
    <>
      {storeMetadata && product ? (
        <>
          <ProductComponent
            product={product}
            partnerId={dataContext.partnerId || ""}
            partnerNetwork={storeMetadata.userNetwork}
            country={data.ownerCountry as PartnerCountry}
            globalOffers={data.globalOffers}
            offerId={offerId}
            dbProducts={cartProducts}
            reviews={review}
          />
          <Outlet
            context={{
              ...dataContext,
              data,
              product,
              storeMetadata,
            }}
          />
        </>
      ) : (
        <EmptyState searchProduct={false} />
      )}
    </>
  );
}
